<ul>
  @for (term of terms(); let index = $index; track term.guid) {
    <li
      class="flex align-center flex-gap"
      [attr.data-test-id]="'term-' + index">
      <button
        matButton
        class="flex justify-start flex-gap-half"
        (click)="downloadTerms(term)">
        <mat-icon class="blue">picture_as_pdf</mat-icon>
        <p class="term-name">{{ term.name }}</p>
      </button>
    </li>
  }
</ul>
